import '../../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import FindTheCorrectWord from './FindTheCorrectWord'


axios.defaults.withCredentials = true;

function FindTheCorrectWordNoAudio() {
    return (
        <FindTheCorrectWord
            audio={false}
            instructions={"Quale parola è scritta correttamente? Cerca di essere più veloce che puoi!"}
            type={"alternative visivo"}>
        </FindTheCorrectWord>
    );
}

export default FindTheCorrectWordNoAudio;

